module.exports = __webpack_public_path__ + "media/images/company/company_03-30e85a5b27837ece8d2b26d169cbc749.jpg";